import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import SearchInput from "../SearchInput/SearchInput";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import SelectInput from "../SelectInput/SelectInput";
import RefreshIcon from "@mui/icons-material/Refresh";
import Buttons from "../Buttons/Buttons";
import { BackArrow } from "../../assets/icons-components/Icons";
import DateButton from "../DateButton/DateButton";
import HighlightedPickersDay from "../HighlightedPickersDay/HighlightedPickersDay";
import { TIME_ZONES } from "../../utils/timeZones";
import "./ActivityLogsFilterBar.scss";

const ActivityLogsFilterBar = ({
  searchQuery,
  onSearchChange,
  onRefresh,
  onBack,
  hasActiveFilters,
  onClearFilters,
  activityType,
  onActivityTypeChange,
  onRemoveActivityTag,
  activityOptions,
  calendarOpen,
  onCalendarOpen,
  onCalendarClose,
  selectedDate,
  onDateChange,
  highlightedDates,
  timeZone,
  onTimeZoneChange,
}) => {
  const selectedValues = Array.isArray(activityType)
    ? activityType.map(String)
    : activityType !== undefined && activityType !== null && activityType !== ""
    ? [String(activityType)]
    : [];

  const selectedTags = activityOptions.filter((opt) =>
    selectedValues.includes(String(opt.value))
  );

  return (
    <div className="activity_logs_filter_wrapper">
      <div className="activity_toolbar">
        <div className="activity_toolbar_left">
          <CustomTooltip title="Back to Logs">
            <span>
              <Buttons
                icon={<BackArrow />}
                ariaLabel="Back to Logs"
                onClick={onBack}
                style={{
                  border: "none",
                  padding: 0,
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </span>
          </CustomTooltip>
          <div className="activity_search_wrap">
            <SearchInput
              className="mainadd_header2_center_searchbar"
              name="searchQuery"
              placeholder="Search by activity type or description"
              value={searchQuery}
              onChange={onSearchChange}
            />
          </div>
        </div>

        <div className="activity_toolbar_right">
          <div className="filter_control filter_control--select">
            <SelectInput
              name="activityType"
              value={activityType}
              onChange={(e) => onActivityTypeChange(e.target.value)}
              options={activityOptions}
              placeholder="Activity Type"
              multiple={true}
              style={{ minWidth: 170, maxWidth: 210 }}
            />
          </div>

          <div className="filter_control filter_control--timezone">
            <CustomTooltip title="Timezone for displayed log timestamps">
              <div>
                <SelectInput
                  name="timeZone"
                  value={timeZone}
                  onChange={(e) => onTimeZoneChange(e.target.value)}
                  options={TIME_ZONES}
                  placeholder="Time Zone"
                  style={{ minWidth: 160, maxWidth: 190 }}
                />
              </div>
            </CustomTooltip>
          </div>

          <div className="filter_control filter_control--date">
            <DatePicker
              open={calendarOpen}
              onOpen={onCalendarOpen}
              onClose={onCalendarClose}
              value={selectedDate}
              onChange={(date) => onDateChange(date ? [date] : [])}
              views={["year", "month", "day"]}
              slots={{ field: DateButton, day: HighlightedPickersDay }}
              slotProps={{
                field: { value: selectedDate, onClick: onCalendarOpen },
                day: { highlightedDates },
              }}
            />
          </div>

          <CustomTooltip title="Refresh logs">
            <button
              type="button"
              className="activity_refresh_btn"
              aria-label="Refresh logs"
              onClick={onRefresh}
            >
              <RefreshIcon className="refresh_icon" />
            </button>
          </CustomTooltip>
        </div>
      </div>

      {selectedTags.length > 0 && (
        <div className="activity_filter_tags">
          <span className="tags_label">Active Filters:</span>
          <div className="tags_list">
            {selectedTags.map((tag) => (
              <span key={tag.value} className="filter_tag">
                {tag.label}
                <button
                  type="button"
                  className="filter_tag_remove"
                  onClick={() => onRemoveActivityTag(tag.value)}
                  title="Remove filter"
                >
                  ✕
                </button>
              </span>
            ))}
            <button
              type="button"
              className="clear_all_tags"
              onClick={onClearFilters}
            >
              Clear All
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActivityLogsFilterBar;
